import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=7b8bbf32&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=ts"
export * from "./ModalPopup.vue?vue&type=script&lang=ts"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=7b8bbf32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8bbf32",
  null
  
)

export default component.exports